<template>
	<v-app>
		<HeaderTemplate></HeaderTemplate>
		<v-main>
			<router-view />
		</v-main>
		<FooterTemplate></FooterTemplate>
	</v-app>
</template>

<script>
	import { from } from "env-var"; // logger

	import HeaderTemplate from "@/templates/Header.vue";
	import FooterTemplate from "@/templates/Footer.vue";

	const env = from(process.env, {});
	//const env = from(process.env, {}, logger);
	const appName = env.get("VUE_APP_NAME").required().asString();
	const baseUrl = env.get("VUE_APP_BASE_URL").required().asString();
	const endpoint = env.get("VUE_APP_ENDPOINT").required().asString();
	const storage = env.get("VUE_APP_STORAGE_FILES").asString();
	//const API_KEY = env.get("VUE_APP_TOKEN_API").required().asString();
	//console.log("🚀 ~ API_KEY:", env);

	export default {
		name: "App",

		metaInfo: {
			title: "Instituto de Mexicanas y Mexicanos en el Exterior",
			titleTemplate: "%s | IMME",
		},

		components: {
			HeaderTemplate,
			FooterTemplate,
		},

		data: () => ({
			meta: {
				app_name: process.env.VUE_APP_NAME,
				base_url: process.env.VUE_APP_BASE_URL,
				endpoint: process.env.VUE_APP_ENDPOINT,
				storage_files: process.env.VUE_APP_STORAGE_FILES,
			},
		}),

		mounted() {
			document.title = `Concursos | ${this.meta.app_name}`;
		},
	};
</script>
<style>
	.banner-ime {
		position: fixed;
		z-index: 999;
		bottom: 40px;
		right: 40px;
	}
</style>
